import { Observable } from 'rxjs';
import { debounce } from '../../operator/debounce';
Observable.prototype.debounce = debounce;
//# sourceMappingURL=debounce.js.map